import { render } from "./CheckboxFieldComponent.vue?vue&type=template&id=480d02a0"
import script from "./CheckboxFieldComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__